import { Button, ButtonProps } from 'react-bootstrap';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React from 'react';

interface IProps extends ButtonProps {
  icon?: FontAwesomeIconProps['icon'];
  onClick?: () => void;
  iconProps?: Omit<FontAwesomeIconProps, 'icon'>
}

const ButtonWithIcon = (props: IProps) => {
  const { children, icon, iconProps, ...otherProps } = props;

  return (
    <Button {...otherProps}>
      {
        icon &&
        <FontAwesomeIcon {...iconProps} icon={icon} style={{ marginRight: '0.5em' }} />
      }
      {children}
    </Button>
  )
}

export default ButtonWithIcon;
